module.exports = __webpack_public_path__ + "img/madeInGermany.b4ac3d3.webp";